import React, {useState} from "react";
import reachGoalYM from "@/Helpers/ReachGoalYM";
import reachGoalGA from "@/Helpers/ReachGoalGA";
import Link from "@/Layouts/Link";
import MainLogo from "@/Components/MainLogo";
import Svg from "@/Components/Svg";
import "@/Scss/footer.scss";

const Footer = (props) => {
    const {mobileApp = false, hideFooter = false, ratingYandexMarket} = props
    const year = new Date();

    if (mobileApp) return null;

    return (
        <footer className={`footer`}>
            {!hideFooter && (
                <>
                    <div className={`container`}>
                        <Navigations {...props} />
                    </div>
                    <div className={`footer__line`}></div>
                    <div className={`container`}>
                        <div className={`footer__apps`}>
                            {/*<a href={`https://reviews.yandex.ru/shop/platina-kostroma.com`}*/}
                            <a href={`https://reviews.yandex.ru/shop/platina-jewelry.ru`}
                               className={`yaMarket`}
                               target={`_blank`}
                            >
                                <div className={`yaMarket__icon`}>
                                    <Svg id={`yandex-reviews`} className={`svg__yandexMarket`} />
                                </div>
                                <div className={`yaMarket__rating`}>
                                    <p className={`count`}>{ratingYandexMarket}</p>
                                    <Svg id={`yandex-market-star`} className={`svg__yandexMarketStar`} />
                                    <Svg id={`yandex-market-star`} className={`svg__yandexMarketStar`} />
                                    <Svg id={`yandex-market-star`} className={`svg__yandexMarketStar`} />
                                    <Svg id={`yandex-market-star`} className={`svg__yandexMarketStar`} />
                                    <Svg id={`yandex-market-star`} className={`svg__yandexMarketStar`} />
                                </div>
                            </a>
                            <div className={`followApps`}>
                                <a
                                    href="https://apps.apple.com/ru/app/platina-%D0%BC%D0%B0%D0%B3%D0%B0%D0%B7%D0%B8%D0%BD-%D1%83%D0%BA%D1%80%D0%B0%D1%88%D0%B5%D0%BD%D0%B8%D0%B9/id6450421426"
                                    className={`followApps__item`}
                                    target={`_blank`}
                                >
                                    <Svg id={`app-store`} className={`svg--appStore`} />
                                </a>
                                <a
                                    href="https://play.google.com/store/apps/details?id=com.platinakostroma.androidapp"
                                    className={`followApps__item`}
                                    target={`_blank`}
                                >
                                    <Svg id={`google-play`} className={`svg--googlePlay`} />
                                    {/*<IconGooglePlay />*/}
                                </a>
                                <a
                                    href="https://appgallery.huawei.com/app/C106976539"
                                    className={`followApps__item`}
                                    target={`_blank`}
                                >
                                    <Svg id={`app-gallery`} className={`svg--appGallery`} />
                                    {/*<IconAppGallery />*/}
                                </a>
                                <a
                                    href="https://www.rustore.ru/catalog/app/com.platinakostroma.androidapp"
                                    className={`followApps__item`}
                                    target={`_blank`}
                                >
                                    <Svg id={`ruStore`} className={`svg--ruStore`} />
                                    {/*<IconRuStore />*/}
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className={`footer__line`}></div>
                </>
            )}
            <div className={`footer footer__year`}>
                <div className={`container`}>
                    <p>&copy;&nbsp;ООО&nbsp;ЮЗ&nbsp;&laquo;ПЛАТИНА&raquo;, 2015 - {year.getFullYear()}</p>
                </div>
            </div>
        </footer>
    );
}

const Navigations = (props) => {
    const {b2bUrl = ''} = props;

    const [navState, setNavState] = useState({
        nav_0: false,
        nav_1: false,
        nav_2: false,
        nav_3: false
    });

    const toggleNav = (id) => {
        setNavState(prevState => ({
            ...prevState,
            [`nav_${id}`]: !prevState[`nav_${id}`]
        }));
    };

    return (
        <div className={`footer__nav`}>
            <div className={`footer__navItem`}>
                <div className={`footer__navItemTitleContainer`}>
                    <Link href={`/about-company`} className={`footer__navItemTitle`}>О компании</Link>
                    <div className={`footer__navItemIcon${navState.nav_0 ? ' down' : ''}`} onClick={() => toggleNav(0)}>
                        <Svg id={`keyboardArrowDownOutlinedIcon`} className={`svg__keyboardArrowDownOutlinedIcon`} />
                    </div>
                </div>
                <div className={`footer__navItemContentContainer${navState.nav_0 ? ' visible' : ''}`}>
                    <div className={`footer__navItemContent`}>
                        <Link href={`/news`} className={`footer__navItemLink`}>
                            Новости и пресс-релизы
                        </Link>
                        <Link href={`/jobs`} className={`footer__navItemLink`}>Вакансии</Link>
                        <Link href={`/philosophy`} className={`footer__navItemLink`}>Философия</Link>
                        <Link href={`/contacts`} className={`footer__navItemLink`}>Контакты</Link>
                        <Link href={`/polzovatelskoe-soglashenie`} className={`footer__navItemLink`}>
                            Пользовательское соглашение
                        </Link>
                        <Link href={`/politika-konfidencialnosti`} className={`footer__navItemLink`}>
                            Политика конфиденциальности
                        </Link>
                        <Link href={`/sitemap`} className={`footer__navItemLink`}>Карта сайта</Link>
                    </div>
                </div>
            </div>
            <div className={`footer__navItem`}>
                <div className={`footer__navItemTitleContainer`}>
                    <Link href={`/catalog`} className={`footer__navItemTitle`}>Украшения</Link>
                    <div className={`footer__navItemIcon${navState.nav_1 ? ' down' : ''}`} onClick={() => toggleNav(1)}>
                        <Svg id={`keyboardArrowDownOutlinedIcon`} className={`svg__keyboardArrowDownOutlinedIcon`} />
                    </div>
                </div>
                <div className={`footer__navItemContentContainer${navState.nav_1 ? ' visible' : ''}`}>
                    <div className={`footer__navItemContent`}>
                        <Link href={`/catalog`} className={`footer__navItemLink`}>Каталог</Link>
                        <Link href={`/catalog/kolca`} className={`footer__navItemLink`}>Кольца</Link>
                        <Link href={`/catalog/sergi`} className={`footer__navItemLink`}>Серьги</Link>
                        <Link href={`/catalog/podveski`} className={`footer__navItemLink`}>Подвески</Link>
                        <Link href={`/catalog/broshi`} className={`footer__navItemLink`}>Броши</Link>
                        <Link href={`/catalog/cepi`} className={`footer__navItemLink`}>Цепи</Link>
                    </div>
                </div>
            </div>
            <div className={`footer__navItem`}>
                <div className={`footer__navItemTitleContainer`}>
                    <Link href={`/b2b`} className={`footer__navItemTitle`}>Партнерам</Link>
                    <div className={`footer__navItemIcon${navState.nav_2 ? ' down' : ''}`} onClick={() => toggleNav(2)}>
                        <Svg id={`keyboardArrowDownOutlinedIcon`} className={`svg__keyboardArrowDownOutlinedIcon`} />
                    </div>
                </div>
                <div className={`footer__navItemContentContainer${navState.nav_2 ? ' visible' : ''}`}>
                    <div className={`footer__navItemContent`}>
                        <a href={`${b2bUrl}/web-create-account`} className={`footer__navItemLink`} target={`_blank`}>
                            Стать партнёром
                        </a>
                        <a href={`${b2bUrl}/web-login`} className={`footer__navItemLink`} target={`_blank`}>
                            Личный кабинет партнера
                        </a>
                    </div>
                </div>
            </div>
            <div className={`footer__navItem`}>
                <div className={`footer__navItemTitleContainer`}>
                    <div className={`footer__navItemTitle`}>Покупателям</div>
                    <div className={`footer__navItemIcon${navState.nav_3 ? ' down' : ''}`} onClick={() => toggleNav(3)}>
                        <Svg id={`keyboardArrowDownOutlinedIcon`} className={`svg__keyboardArrowDownOutlinedIcon`} />
                    </div>
                </div>
                <div className={`footer__navItemContentContainer${navState.nav_3 ? ' visible' : ''}`}>
                    <div className={`footer__navItemContent`}>
                        <Link href={`/gift-certificate`} className={`footer__navItemLink`}>
                            Подарочные сертификаты
                        </Link>
                        <Link href={`/platina-benefits`} className={`footer__navItemLink`}>
                            Бонусная программа
                        </Link>
                        <Link href={`/sber-credit-terms`} className={`footer__navItemLink`}>
                            Условия кредитования и рассрочки
                        </Link>
                        <Link href={`/dolyame`} className={`footer__navItemLink`}>Покупка долями</Link>
                        <Link href={`/split`} className={`footer__navItemLink`}>Покупка в сплит</Link>
                        <Link href={`/delivery`} className={`footer__navItemLink`}>Оплата и доставка</Link>
                        <Link href={`/vozvrat-tovara`} className={`footer__navItemLink`}>Возврат товара</Link>
                        <Link href={`/quality-guarantee`} className={`footer__navItemLink`}>
                            Гарантии качества
                        </Link>
                        <Link href={`/faq`} className={`footer__navItemLink`}>Часто задаваемые вопросы</Link>
                    </div>
                </div>
            </div>
            <div className={`footer__navItem`}>
                <MainLogo className={`footer__logoBox`} />
                <div className={`footer__contactsContainer`}>
                    <span className={`text`}>MAX, Telegram</span>
                    <a className={`footerPhone`}
                       onClick={() => {
                           reachGoalYM('phone_click');
                           reachGoalGA('phone_click');
                       }}
                       href="tel:+79109522022">+7 910 952-20-22</a>
                    <div className={`footer__contacts`}>
                        {/*<div className={`viber`}>*/}
                        {/*    <a href={`viber://chat?number=%2B79109522022`}>*/}
                        {/*        <Svg id={`viber`} className={`svg--viber`} />*/}
                        {/*    </a>*/}
                        {/*</div>*/}
                        {/*<div className={`whatsapp`}>*/}
                        {/*    <a href="https://wa.me/79109522022">*/}
                        {/*        <Svg id={`whatsapp`} className={`svg--whatsapp`} />*/}
                        {/*    </a>*/}
                        {/*</div>*/}
                        <div className={`max`}>
                            <a href="https://max.ru/u/f9LHodD0cOJrp9GGSadyrX__BRbqLq0CqQSijuZcF41L_Qe3TmiNWDBVbX4">
                                <Svg id={`max`} className={`svg--max`} />
                            </a>
                        </div>
                        <div className={`telegram`}>
                            {/*<a href="https://t.me/platina_jewelry_chat">*/}
                            <a href="https://t.me/PlatinaManagerBot">
                                <Svg id={`telegram`} className={`svg--telegram`} />
                            </a>
                        </div>
                    </div>
                </div>
                <p className={`footer__socialTitle`}>Мы в социальных сетях</p>
                <div className={`footer__socials`}>
                    <div className={`footer__socialItem`}>
                        <a href="https://vk.com/platina_jewelry"
                           rel="noopener noreferrer"
                           target={`_blank`}>
                            <Svg id={`vk`} className={`svg__vk`} />
                        </a>
                    </div>
                    <div className={`footer__socialItem`}>
                        <a href="https://ok.ru/platina.kostroma"
                           rel="noopener noreferrer"
                           target={`_blank`}>
                            <Svg id={`ok`} className={`svg__ok`} />
                        </a>
                    </div>
                    <div className={`footer__socialItem`}>
                        <a href="https://www.youtube.com/c/PlatinaJewelry"
                           rel="noopener noreferrer"
                           target={`_blank`}>
                            <Svg id={`yt`} className={`svg__yt`} />
                        </a>
                    </div>
                    <div className={`footer__socialItem`}>
                        <a href="https://t.me/platina_jewelry"
                           rel="noopener noreferrer"
                           target={`_blank`}>
                            <Svg id={`telegram`} className={`svg__telegram`} />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Footer;
